import { Component, OnInit,ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {SummaryInfoComponent} from '../summary-info/summary-info.component';
import {SelectRolesComponent} from '../select-roles/select-roles.component';
import { OtherDocumentComponent} from '../other-document/other-document.component';
import {CreatingUsersComponent} from '../creating-users/creating-users.component';
import { CompanyService } from 'src/app/services/company.service';

@Component({
  selector: 'app-create-client',
  templateUrl: './create-client.component.html',
  styleUrls: ['./create-client.component.scss']
})
export class CreateClientComponent implements OnInit {
  companyId;
  tabsList:any[]; 
  index = 0;
  activeTabIndex = 0;
  observableSubscription$ = new Subject();
  editingContent = false;
  @ViewChild(SummaryInfoComponent) summaryInfoComponent: SummaryInfoComponent; 
  @ViewChild (SelectRolesComponent) selectRolesComponent: SelectRolesComponent;
  @ViewChild (OtherDocumentComponent) otherDocumentComponent: OtherDocumentComponent;
  @ViewChild (CreatingUsersComponent) creatingUsersComponent: CreatingUsersComponent;
  currentState = ''
  creationType = null;
  parentData: any;

  constructor( private activatedRoute: ActivatedRoute,
    private companyService: CompanyService,private router: Router,) { 
      
    this.activatedRoute.params
      .pipe(takeUntil(this.observableSubscription$))
      .subscribe(parameter => {
        let parameterId = null;
        if (parameter.hasOwnProperty('id')) {    
          parameterId = parameter?.id;
          this.editingContent = true;
          this.companyId = parameterId ? parameterId : null;
          if(this.companyId !=='null'){
            this.activatedRoute.queryParams.subscribe((params) => {
              console.log('paramsparams', params);
              if(params?.type){
                this.creationType = params?.type;
              }
            }); 
            console.log('parameter', parameter); 
            this.companyService.getCompaniesById(parameter?.id).subscribe(data => {
              this.currentState = data.status?.code;
              if(this.editingContent && this.currentState == 'ACTV'){
                this.tabsList = [
                  { 'tabName':'1. Company Info','tabIconName':'Petition'},
                  { 'tabName':'2. Other Details & Documents','tabIconName':'Petition'}
                ];
              }
              else
              this.tabsList = [
                { 'tabName':'1. Company Info','tabIconName':'Petition'},
                { 'tabName':'2. Other Details & Documents','tabIconName':'Petition'},
                { 'tabName':'3. Select Roles','tabIconName':'Petition'},
                { 'tabName':'4. Creating Users','tabIconName':'Petition'},
                { 'tabName':'5. Add Beneficiaries','tabIconName':'Petition'},
                { 'tabName':'6. Review Summary','tabIconName':'Petition'}
              ];
            });
            this.onLoadData();
          } else {
            this.onLoadData();
            this.tabsList = [
              { 'tabName':'1. Company Info','tabIconName':'Petition'},
              { 'tabName':'2. Other Details & Documents','tabIconName':'Petition'}
            ];
          }
          
        } else {
          this.tabsList = [
            { 'tabName':'1. Company Info','tabIconName':'Petition'},
            { 'tabName':'2. Other Details & Documents','tabIconName':'Petition'},
            { 'tabName':'3. Select Roles','tabIconName':'Petition'},
            { 'tabName':'4. Creating Users','tabIconName':'Petition'},
            { 'tabName':'5. Add Beneficiaries','tabIconName':'Petition'},
            { 'tabName':'6. Review Summary','tabIconName':'Petition'}
          ];
        }
      });
      
      
  }

  onLoadData(){
    this.activatedRoute.queryParams.subscribe((params) => {
      console.log('paramsparamseeeee', params);
      if(params?.type){
        this.creationType = params?.type;
      }
      if(params?.data){ 
        console.log('dataaaaa', JSON.parse(params?.data))
        this.parentData = JSON.parse(params?.data);
        console.log('Specific key:', this.parentData);
      }
    });
  }

  ngOnInit() {
  }

  handleChange(e) {
    this.activeTabIndex = e.index;
  }

  parentListener(data:number){
    this.activeTabIndex = data;
    if(data == 1){
      this.otherDocumentComponent.getallData();
    }
    if(data == 2){
      this.selectRolesComponent.getUserRoles();
      this.selectRolesComponent.getUserDetails();
    }
    if(data == 3){
      this.creatingUsersComponent.getUserRoles();
    }
    if(data == 5){
      this.summaryInfoComponent.getReviewSummaryDetails();
    }
  }

  idListener(data:number){
    this.companyId = data;
  }

  onClickBack(){
    this.router.navigate(['/attorney-landing/clients/clients']);
  }
  

}
